// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1BiH3","buttons":"SendReceipts_buttons__1u4av","email":"SendReceipts_email__pAwGC","bookApptTitle":"SendReceipts_bookApptTitle__2LPdY"};